<template>
  <div class="card">
    <div class="card-header">
      <h5>{{ title }}</h5>
    </div>
    <div class="card-body py-2">
      <div class="list-container pt-3 mb-4">
        <!-- <app-icon-check class="mr-2" v-for="app in apps" :showcheckbox="showcheckbox" :showoutline="showoutline"
                    :key="app.id" @select="select" :object="app" :checked="checked" :icon="app.icon" :name="app.name"></app-icon-check> -->
        <app-icon-check
          class="mr-2"
          v-for="obj in objects"
          :showcheckbox="showcheckbox"
          :showoutline="showoutline"
          :key="reloadkey + type + '-' + obj.id"
          ref="appiconcheck"
          @select="select"
          @unselect="unselect"
          :type="type"
          :object="obj"
          :fetchobj="fetchedObject"
          :checked="checked"
          :icon="obj.icon != undefined ? obj.icon : obj.previewImage"
          :name="type != 'APP' ? obj.namesMap[$locale] : obj.name"
        ></app-icon-check>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MapPinIcon,
  PlusSquareIcon,
  ClipboardIcon,
  FileTextIcon,
  TrashIcon,
  EditIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "vue-feather-icons";
import AppIconCheck from "./AppIconCheck.vue";
export default {
  components: {
    AppIconCheck,
    ChevronLeftIcon,
    ChevronRightIcon,
  },

  name: "AppIconList",

  props: {
    type: String,
    showcheckbox: Boolean,
    showoutline: Boolean,
    title: String,
    objects: Array,
    fetchedObject: Object,
  },

  computed: {},

  watch: {
    fetchedObject:{
            handler(val) {
                if(Object.keys(Object.assign({}, val)).length !== 0){
                  this.reloadkey++;
                }
            },
            deep: true,
            immediate:true,
        }, 
    SelectedObject: function(val) {
      if (this.showcheckbox && this.type == "APP") {
        this.$emit("pushSelectedApp", val);
      }
      if (this.showoutline && this.type == "PLACEMENTTYPE") {
        this.$emit("pushselectedPlacementType", val);
      }
      if (this.showoutline && this.type == "PLACEMENT") {
        this.$emit("pushselectedPlacement", val);
      }
    },
  },

  created(){
  },

  mounted() {
  },

  data() {
    return {
      icon: "",
      checked: false,
      name: "",
      selectedApps: [],
      SelectedObject: null,

      reloadkey: 0,

      objects: [],
    };
  },
  methods: {
    select(event) {
      var obj = Object.assign({}, event);

      if (this.SelectedObject == null) {
        this.SelectedObject = obj;
      } else {
        this.uncheckAll(obj);
        this.SelectedObject = obj;
      }
    },
    unselect(event) {
      var obj = Object.assign({}, event);
      if(this.SelectedObject == null){
        for (var i = 0; i < this.$refs.appiconcheck.length; i++) {
          this.$refs.appiconcheck[i].check(obj);
        }
      }else if (this.SelectedObject.id == obj.id) {
        this.SelectedObject = null;
      }
    },
    uncheckAll(select) {
      for (var i = 0; i < this.$refs.appiconcheck.length; i++) {
        this.$refs.appiconcheck[i].uncheck(select);
      }
    },
  },
};
</script>

<style scoped>
.list-container {
  overflow-y: auto;
  display: flex;
}

.card-header h1,
.card-header > h2,
.card-header > h3,
.card-header > h4,
.card-header > h5 {
  color: #2f3452 !important;
  text-transform: none !important;
}
</style>
